



















































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Mutations } from '@/ts/store/Constants';
import CloseButton from '@/components/Buttons/CloseButton.vue';
import BackButton from '@/components/Buttons/BackButton.vue';
import TypesView from '@/components/Overlays/HomeAssistant/TypesView.vue';
import CategoriesView from '@/components/Overlays/HomeAssistant/CategoriesView.vue';
import QuestionsView from '@/components/Overlays/HomeAssistant/QuestionsView.vue';
import SearchResultsView from '@/components/Overlays/HomeAssistant/SearchResultsView.vue';
import { HomeAssistantView } from '@/ts/HococoInterfaces';

import { Keyboard, KeyboardInfo } from '@capacitor/keyboard';

@Component({
    components: {
        CloseButton,
        BackButton,
        TypesView,
        CategoriesView,
        QuestionsView,
        SearchResultsView,
    },
    computed: {
        ...mapGetters({
            userTicketAllTypes: 'UserTickets/getUserTicketAllTypes',
        }),
    },
})
export default class HomeAssistant extends Vue {
    public keyboardListenerAdded: boolean = false;
    public keyboardVisible: boolean = false;

    constructor() {
        super();

        this.initializeKeyboardListener();
    }

    get mainView(): HomeAssistantView {
        return this.$store.getters['HomeAssistant/getHomeAssistantMainViews'];
    }

    get prevView(): string {
        return this.$store.getters['HomeAssistant/getPrevHomeAssistantViews'];
    }

    get currentView(): HomeAssistantView {
        return this.$store.getters['HomeAssistant/getCurrentHomeAssistantViews'];
    }

    get searchQuery(): string {
        return this.$store.getters['HomeAssistant/getSearchQuery'];
    }

    set searchQuery(value: string) {
        this.$store.commit(Mutations.SET_HOME_ASSISTANT_SEARCH_QUERY_VALUE, value);
    }

    get isMainView(): boolean {
        return this.mainView.component === this.currentView.component;
    }

    public backView() {
        const resetMutations = this.currentView.resetMutations;

        this.currentView.component === 'SearchResultsView'
            ? this.$store.commit(Mutations.SET_HOME_ASSISTANT_CURRENT_VIEW, this.currentView.prevComponent)
            : this.$store.commit(Mutations.SET_HOME_ASSISTANT_CURRENT_VIEW, this.prevView);

        resetMutations.forEach((mutation: any) => this.$store.commit(mutation, null));
    }

    public changeView() {
        this.$store.commit(Mutations.SET_HOME_ASSISTANT_CURRENT_VIEW, 'SearchResultsView');
    }

    public initializeKeyboardListener(): void {
        if (this.keyboardListenerAdded === true) {
            return;
        }

        if (this.$store.state.Viewport.deviceInfo.platform === 'web') {
            this.keyboardListenerAdded = true;
            return;
        }

        Keyboard.addListener('keyboardDidShow', (info: KeyboardInfo) => {
            this.keyboardVisible = true;
        });

        Keyboard.addListener('keyboardDidHide', () => {
            this.keyboardVisible = false;
        });

        this.keyboardListenerAdded = true;
    }

    public closeOverlay() {
        this.$store.commit(Mutations.SET_HOME_ASSISTANT_VISIBILITY, false);
        this.$store.commit(Mutations.RESET_HOME_ASSISTANT_STORE_STATE);
    }

    public openReportIssueOverlay() {
        this.$store.commit(Mutations.SET_REPORT_ISSUE_OVERLAY_VISIBILITY, true);
    }
}
